var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("sc-confirmation-modal", {
        attrs: {
          "is-active": _vm.confirmationModalActive,
          type: "danger",
          title: "Excluir modelo",
          "confirm-text": "Sim, excluir",
          messages: [
            "Tem certeza que deseja excluir o modelo de fatura?",
            "Caso queira fazer auditoria de fatura dessa transportadora novamente, basta criar um novo modelo."
          ]
        },
        on: {
          "update:isActive": function($event) {
            _vm.confirmationModalActive = $event
          },
          onConfirm: function() {
            return _vm.removeBillingTemplate(_vm.templateSelectedForRemoval)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "sc-table",
        {
          attrs: {
            id: "billing-templates-table",
            loading: _vm.loading,
            data: _vm.templates,
            bordered: false,
            hoverable: false,
            striped: false,
            scrollable: false
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var row = ref.row
                return [
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Transportadora e método de entrega",
                        centered: false
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.getTemplateLogisticProviderInfo(row)) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Nome do modelo", centered: false } },
                    [_vm._v("\n        " + _vm._s(row.name) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Criado em", centered: false } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(row.created, "DD/MM/YY - HH:mm")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Ações", width: "80" } },
                    [
                      _c(
                        "sc-dropdown",
                        { attrs: { position: "is-bottom-left" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "field",
                              attrs: { slot: "trigger" },
                              slot: "trigger"
                            },
                            [_c("i", { staticClass: "fas fa-ellipsis-v" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-dropdown-item",
                            { attrs: { "has-link": "" } },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "template-action",
                                  attrs: {
                                    to: {
                                      name: "create-billing-template",
                                      query: { view: row.id }
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "far fa-eye" }),
                                  _vm._v(" Visualizar modelo\n            ")
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("sc-dropdown-item", { attrs: { separator: "" } }),
                          _vm._v(" "),
                          _c(
                            "sc-dropdown-item",
                            {
                              staticClass: "template-action",
                              on: {
                                click: function($event) {
                                  _vm.selectForDeletion(row.id)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "far fa-times-circle" }),
                              _vm._v(" Excluir modelo\n          ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "template",
            { attrs: { slot: "empty" }, slot: "empty" },
            [
              _c("sc-table-empty", {
                attrs: { icon: "box-open", message: _vm.emptyTableTemplate }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8eda9c76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eda9c76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/components/BillingTemplatesTable.vue
// module id = null
// module chunks = 